import { IEmailButtonBlock } from 'common/builder/blocks/blockInterfaces'
import { FlowChartButtonBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartButtonBuilder'
import { FlowChartButtonStatsBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartButtonStatsBuilder'
import { FlowChartNextStepBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartNextStepBuilder'
import {
  ConverterRule,
  EmailContentRulePayload,
} from 'common/builder/components/chart/FlowChart/lib/types'
import { replaceFieldsInString } from 'common/builder/components/chart/FlowChart/lib/utils/replaceFieldsInString'
import { ButtonAppearance } from 'common/builder/components/chart/FlowChart/types/FlowChartButton'
import {
  EmailContentButton,
  EmailContentType,
} from 'common/builder/components/chart/FlowChart/types/FlowChartEmailContent'
import { BlockType } from 'common/builder/constants/BlockType'

export const EmailButtonContentConverterRule: ConverterRule<
  IEmailButtonBlock,
  EmailContentButton,
  EmailContentRulePayload
> = {
  predicate: (entity: IEmailButtonBlock) => entity?.type === BlockType.EMAIL_BUTTON,
  convert: (entity: IEmailButtonBlock, { fields, buttonsMap }) => {
    const buttonId = entity.buttons[0]
    const button = buttonsMap[buttonId]

    /**
     * If button is not found in the buttonsMap, we create an empty button
     * with the caption from the IEmailButtonBlock.
     * This logic is needed as we are creating button only when specifinyg
     * next step for the IEmailButtonBlock
     */

    return {
      id: entity.id,
      type: EmailContentType.BUTTON,
      data: {
        button: new FlowChartButtonBuilder(button ? buttonId : 'emptyButton_' + entity.id)
          .withCaption(replaceFieldsInString(entity.text, fields))
          .withAppearance(ButtonAppearance.DEFAULT_CENTERED)
          .withIsInteractive(false)
          .withNextStep(button ? new FlowChartNextStepBuilder(buttonId).build() : null)
          .withStats(new FlowChartButtonStatsBuilder().build())
          .build(),
      },
    }
  },
}
